/* Annodiamo — Schede prodotto. Limita gli effetti alle pagine prodotto. */
(function () {
  function init() {
    document.querySelectorAll('.product-information').forEach(function (area) {
      var box = area.querySelector('[data-annodiamo-product-bottom]');
      var klarna = area.querySelector('[data-annodiamo-klarna]');
      if (!box || !klarna || box.dataset.annodiamoReady === '1') return;
      box.dataset.annodiamoReady = '1';
      var variants = [];
      try { variants = JSON.parse(box.querySelector('[data-annodiamo-variant-data]')?.textContent || '[]'); } catch(e) {}
      var btn = box.querySelector('[data-annodiamo-buy-now]');
      var error = box.querySelector('[data-annodiamo-buy-error]');
      var rate = klarna.querySelector('[data-annodiamo-rate]');
      var formatter = new Intl.NumberFormat('it-IT', {style:'currency',currency:'EUR'});
      function findForm() { return area.querySelector('product-form-component form[action*="/cart/add"]') || area.querySelector('product-form-component form'); }
      function activeVariant() {
        var id = findForm()?.querySelector('input[name="id"]')?.value;
        return variants.find(function(v){return String(v.id) === String(id)}) || null;
      }
      function update() {
        var variant = activeVariant();
        if (variant && Number.isFinite(Number(variant.price))) {
          rate.textContent = formatter.format(Math.round(Number(variant.price)/3)/100);
          btn.disabled = !variant.available;
        } else {
          var input = findForm()?.querySelector('input[name="id"]');
          btn.disabled = !input?.value || Boolean(area.querySelector('.add-to-cart-button:disabled'));
        }
      }
      function arrangeSize() {
        var source = area.querySelector('[data-ann-custom-size]');
        if (!source) return;
        var original = source.querySelector('a');
        if (!original) return;
        var option = Array.from(area.querySelectorAll('variant-picker .variant-option')).find(function(el) {
          var legend = el.querySelector('legend');
          var name = legend ? legend.textContent : Array.from(el.childNodes).filter(function(node) {
            return node.nodeType === 3;
          }).map(function(node) {
            return node.textContent;
          }).join(' ');
          name = (name || el.querySelector('.ann-option-heading')?.textContent || '').replace(/\s+/g,' ').trim();
          return /dimension|taglia|misur|size/i.test(name);
        });
        if (!option) {
          source.classList.remove('is-placed');
          return;
        }
        if (option.matches('[data-testid="variant-option-single"]') && !option.querySelector('.ann-option-heading')) {
          var textNodes = Array.from(option.childNodes).filter(function(node) {
            return node.nodeType === 3 && /dimension|taglia|misur|size/i.test(node.textContent);
          });
          if (textNodes.length) {
            var heading = document.createElement('strong');
            heading.className = 'ann-option-heading';
            heading.textContent = textNodes.map(function(node) { return node.textContent.trim(); }).join(' ');
            textNodes[0].replaceWith(heading);
            textNodes.slice(1).forEach(function(node) { node.remove(); });
          }
        }
        if (!option.querySelector('.annodiamo-custom-size-slot')) {
          var copy = original.cloneNode(true);
          copy.className = 'annodiamo-custom-size-slot';
          option.appendChild(copy);
        }
        source.classList.add('is-placed');
      }
      function refresh(){window.requestAnimationFrame(function(){arrangeSize();update();});}
      update(); arrangeSize();
      area.addEventListener('change',function(){refresh();setTimeout(refresh,180);setTimeout(refresh,650);});
      document.addEventListener('popstate',refresh);
      var formContainer = area.querySelector('product-form-component');
      if (formContainer) {
        var idInput = formContainer.querySelector('input[name="id"]');
        if (idInput) new MutationObserver(refresh).observe(idInput,{attributes:true,attributeFilter:['value']});
      }
      area.addEventListener('click',function(e) {
        var clicked = e.target.closest('[data-annodiamo-buy-now]');
        if (!clicked || clicked !== btn) return;
        var form = findForm();
        if (!form || btn.disabled) return;
        if (!form.reportValidity()) return;
        error.hidden = true;error.textContent = '';
        var selected = activeVariant();
        if (!form.querySelector('input[name="id"]')?.value || (selected && !selected.available)) {
          error.textContent = 'Seleziona una variante disponibile.';error.hidden = false;return;
        }
        btn.disabled = true;btn.textContent = 'Apertura checkout…';
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js',{
          method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},
          body:new FormData(form)
        }).then(async function(resp){
          if (!resp.ok) {
            var data = await resp.json().catch(function(){return {}});
            throw new Error(data.description || data.message || 'Non è stato possibile aggiungere il tappeto.');
          }
          window.location.assign(root + 'checkout');
        }).catch(function(err){
          error.textContent = err.message || 'Errore di connessione. Riprova.';
          error.hidden = false;btn.textContent = 'Acquista ora';update();
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();